import { format, subDays } from 'date-fns';
import type { DailyAverage, DailyCount } from '../types/platformStats';

export const TREND_DAYS = 30;

/** Fill a 30-day UTC series with zeros for missing dates. */
export function fillDailyCounts(rows: DailyCount[], days = TREND_DAYS): DailyCount[] {
  const map = new Map(rows.map((r) => [r.date, r.count]));
  return buildDateRange(days).map((date) => ({
    date,
    count: map.get(date) ?? 0,
  }));
}

export function fillDailyAverages(rows: DailyAverage[], days = TREND_DAYS): DailyAverage[] {
  const map = new Map(rows.map((r) => [r.date, r.value]));
  return buildDateRange(days).map((date) => ({
    date,
    value: map.get(date) ?? 0,
  }));
}

function buildDateRange(days: number): string[] {
  const today = new Date();
  const result: string[] = [];
  for (let i = days - 1; i >= 0; i--) {
    result.push(format(subDays(today, i), 'yyyy-MM-dd'));
  }
  return result;
}

export function formatShortDate(isoDate: string): string {
  const [, month, day] = isoDate.split('-');
  return `${day}.${month}`;
}
